import React from 'react';
import Paper from '@mui/material/Paper';

const Layout = (props) => {
  return props.children;
};

export default Layout;
